module.exports = __webpack_public_path__ + "media/1_3_1-5.bb9e4d6f.mp3";